export const ACT_NATIONAL_TIMING_NAMES = {
  standard: 'Standard Time, Single Day',
  TC5SINGLE: 'Standard (breaks)',
  TC5MULTI: 'Standard (multi day)',
  TC6: '1.5 time',
  TC7: '1.5 time (multi day)',
  TC2: 'Double (multi day)',
  TC3: 'Triple (multi day)',
  TC8: 'Double for Writing only (single day)',
};

export const NO_WRITING_NAME = 'No writing';
export const PLUS_WRITING_ID = 12;
export const WRITING_NAME = 'Writing';
export const EXTENDED_TIME_ID = 3;
export const EXTENDED_TIME_NAME = 'Extended time';
export const CONTACT_SUPPORT_TEL = '319-337-1510';
export const CONTACT_SUPPORT_TEL_2 = '800-553-6244, ext 1510';
export const CONTACT_SUPPORT_TEL_4 = '800-553-6244, ext 2800';
export const MATERIAL_SERIAL_NUMBER_LENGTH = 9;
export const IRREGULARITIES_NOTES_MAX_LENGTH = 5000;
export const TIME_INTERVAL_PDF_REQUEST = 5000;
export const PAST_EVENTS_LIMIT = 13;

export const INSTITUTION_STATUS = {
  renewalActive: 'RENEWAL',
  renewalReview: 'RENEWAL_TCC_REVIEW',
  renewalComplete: 'RENEWAL_TCC_COMPLETE',
  inReview: 'REQUEST',
  active: 'ACTIVE',
  inactive: 'INACTIVE',
  restrict: 'RESTRICT',
  establish: 'ESTABLISH',
  establishReview: 'ESTABLISH_TCC_REVIEW',
  establishComplete: 'ESTABLISH_TCC_COMPLETE',
};

export const ASSIGNMENT_STATUS = {
  open: 'OPEN',
  renewal: 'RENEWAL',
  reschedule: 'RESCHEDULE',
  closed: 'CLOSED',
  tested: 'TESTED',
};

export const TIMING_CATEGORIES = {
  standard: 'Standard time',
  extended: 'Extended time',
};

export const TIMING_CATEGORIES_NAME = {
  standard: 'standard',
  extended: 'extended',
};

export const EXAM_MODES = {
  paper: 'Paper',
  online: 'Online',
};

export const ROOM_TYPES = {
  noWriting: 'No Writing',
  writing: 'Writing',
  combination: 'Combination',
};

export const EXAMINEE_TYPES = {
  noWriting: 'No writing',
  writing: 'Writing',
};

export const WKYS_EXAMINEE_TYPES = {
  am: 'Applied Math',
  gl: 'Graphic Literacy',
  wd: 'Workplace Documents',
  ncrc: 'NCRC',
};

export const PROGRAM_PARENT_CODES = {
  workKeys: 'workkeys',
};

export const ASSIGNED_STATUS = {
  notAssigned: 'Not assigned',
  assigned: 'Assigned',
};

export const DATE_FORMATS = {
  dayMonthYear: 'dddd, MMMM D, YYYY',
  dayMonthYearShort: 'ddd, MMM D, YYYY',
  monthDayYear: 'MMMM D, YYYY',
  monthShortDayYear: 'MMM D, YYYY',
  monthDayYearDash: 'MM-DD-YYYY',
  monthDayYearShort: 'MM.DD.YYYY',
  dateTimeZone: 'YYYY-MM-DD[T]HH:mm:ssZ',
};

export const PERMISSION_CODES = {
  tcManage: 'test_center_manage',
  eventManage: 'test_center_event_manage',
  roomManage: 'room_manage',
  allRoomAccess: 'room_all_access',
  manualTimerControl: 'room_manual_timer_control',
  testCenterEventRosterManage: 'test_center_event_roster_manage',
  testCenterEventMaterialManage: 'test_center_event_material_manage',
  testCenterEventChecklistManage: 'test_center_event_checklist_manage',
  testCenterEventRoomManage: 'test_center_event_room_manage',
  testCenterEventStaffManage: 'test_center_event_staff_manage',
};

export const INVITATION_STATUS = {
  accept: 'accept',
  decline: 'decline',
};

export const CONTACT_TYPES = {
  alternateContact: 'alternate_contact',
  securityStorageContact: 'security_storage_access',
  securityMaterialsTransferContact: 'security_materials_transfer',
  securityMaterialsReceipt: 'security_materials_receipt',
  securityMaterialsCheckin: 'security_materials_checkin',
  securityAdministerTest: 'security_administer_test',
  securityMaterialsReturn: 'security_materials_return',
};

export const CATEGORY_PRE_TEST = 'center_pretest';
export const CATEGORY_POST_TEST = 'center_posttest';

export const TASK_KEYWORDS = [
  {
    key: '{bold}',
    value: '<b>',
  },
  {
    key: '{/bold}',
    value: '</b>',
  },
];

export const NOTIFICATION_STATUS = {
  viewed: 'VIEWED',
  notViewed: 'NOT_VIEWED',
};

export const ROOM_STATUS = {
  inactive: 'inactive',
  opened: 'opened',
  closed: 'closed',
  submitted: 'submitted',
};

export const LOCATION_STATUS = {
  open: 'OPEN',
  closed: 'CLOSED',
};

export const LOCATION_EVENT_STATUS = {
  open: 'OPEN',
  closed: 'CLOSED',
  establish: 'ESTABLISH',
  renewal: 'RENEWAL',
  tested: 'TESTED',
};

export const USING_TCM_LINKS = {
  resources: 'https://content.act.org/act_tcm/r/Using_TCM',
  answers: '',
};

export const EXAM_CATEGORIES = {
  standard: 'PAPER-STANDARD',
  extended: 'SPECIAL-AUTO',
  single: 'SPECIAL-MANUAL',
  standBy: 'STANDBY',
  onlineStandard: 'ONLINE REGULAR',
  onlineExtended: 'ONLINE EXTENDED TIME',
  onlineSectionRetest: 'ONLINE MODULAR',
};

export const REGISTRATION_TYPES = {
  writing: 'Writing',
  noWriting: 'No Writing',
  sectionRetest: 'Section Retest',
};

export const ASSESSMENT_STATUS = {
  available: 'A',
  launched: 'L',
  completed: 'C',
  terminated: 'T',
  unavailable: 'X',
};

export const ASSESSMENT_LABELS = {
  A: 'Available',
  C: 'Completed',
  L: 'Launched',
  T: 'Terminated',
  X: 'Unavailable',
};

export const REQUEST_UPDATE_TYPE = {
  eventUpdate: 'event_update',
  closeTcEvent: 'event_close',
  rescheduleTcEvent: 'event_reschedule',
};

export const REQUEST_UPDATE_STATUS = {
  cancelled: 'cancelled',
  pending: 'pending',
  inProgress: 'in_progress',
};

export const ONLINE_PROVIDERS = {
  tao: 'tao',
  testNav: 'testnav',
  psi: 'psi',
};

export const ONLINE_PSI_REGS_FILTER = {
  null: 'Not ready',
  ready: 'Ready',
  active: 'Active',
  paused: 'Paused',
  complete: 'Complete',
  marked_complete: 'Marked complete',
};

export const ONLINE_REGS_STATUSES = {
  notReady: 'Not ready',
  N: 'Ready',
  I: 'Active',
  R: 'Resumed',
  E: 'Exited',
  C: 'Complete',
  M: 'Marked complete',
};

export const ONLINE_REGS_STATUS_INITIALS = {
  ready: 'N',
  active: 'I',
  resumed: 'R',
  exited: 'E',
  complete: 'C',
  markedComplete: 'M',
};

export const ONLINE_PSI_REGS_STATUSES = {
  error: 'Error',
  null: 'Not ready',
  ready: 'Ready',
  start: 'Start',
  start_pending: 'Start pending',
  active: 'Active',
  unpause_pending: 'Unpause pending',
  pause_pending: 'Pause pending',
  pause: 'Pause',
  paused: 'Paused',
  unpause: 'Unpause',
  mark_complete_pending: 'Mark complete pending',
  marked_complete: 'Marked complete',
  mark_complete: 'Mark complete',
  complete: 'Complete',
  troubleshoot: 'Troubleshoot',
};

export const ONLINE_PSI_REGS_STATUSES_ACTIONS = {
  null: ['unassignregs', 'troubleshoot'],
  ready: ['start', 'mark_complete', 'troubleshoot'],
  active: ['pause', 'mark_complete', 'troubleshoot'],
  paused: ['unpause', 'mark_complete', 'troubleshoot'],
  error: ['troubleshoot'],
  start_pending: ['troubleshoot'],
  pause_pending: ['troubleshoot'],
  unpause_pending: ['troubleshoot'],
  mark_complete_pending: ['troubleshoot'],
};

export const ONLINE_PSI_REGS_MAPPED_SEND_RECIVED_STATUSES = {
  start: 'active',
  pause: 'paused',
  unpause: 'active',
  markComplete: 'marked_complete',
};

export const STATUS_COLORS = {
  null: '',
  ready: '',
  start_pending: 'green',
  active: 'green',
  pause_pending: 'orange',
  unpause_pending: 'green',
  paused: 'orange',
  error: 'red-status',
  mark_complete_pending: 'blue',
  marked_complete: 'blue',
  complete: 'blue',
};

export const GENDERS = {
  M: 'Male',
  F: 'Female',
  A: 'Another gender',
  X: 'Prefer not to respond',
  FEMALE: 'Female',
  MALE: 'Male',
};
